import { Background } from '@linearb/linui-common/marketing/Background';
import { Card } from '@linearb/linui-common/marketing/Card';
import { SESSION_STORAGE_KEYS, TRACKING } from 'common/constants/constants';
import * as TrackingService from 'common/services/tracking.service';
import BrowserStorageAccessor from 'common/utils/BrowserStorageAccessor';
import { omitFromQsAndSaveInSessionStorage } from 'common/utils/utils';
import QueryString from 'query-string';
import { useEffect } from 'react';
import { useLocation } from 'react-router';
import LoginForm from './LoginForm';
import { Grid } from '@material-ui/core';
import { LinearBLogoNew } from '@linearb/linui-common';
import { StyledGridContainer, StyledLogoContainer } from './Login.style';

const sessionStorageAccessor = BrowserStorageAccessor().session;

const Login = ({ toggleModal }) => {
  const location = useLocation<{ error: unknown }>();
  const search = QueryString.parse(window.location.search);
  const {
    redirectTo = null,
    invitation_id: invitationId,
    invitation_expired: invitationExpired
  } = search;
  const authFlow = sessionStorageAccessor.get(SESSION_STORAGE_KEYS.AUTH_FLOW);

  useEffect(() => {
    if (invitationId) {
      TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
        page: TRACKING.PAGES.ONBOARDING,
        page_tag: TRACKING.PAGE_TABS.SIGN_IN,
        context: {
          invitation_id: invitationId
        }
      });

      omitFromQsAndSaveInSessionStorage(
        SESSION_STORAGE_KEYS.INVITATION_ID,
        'invitation_id'
      );
    }

    if (redirectTo) {
      sessionStorageAccessor.set(SESSION_STORAGE_KEYS.REDIRECT_TO, redirectTo);
    }
  }, []);

  return (
    <Background
      sx={{
        height: '100vh',
        width: '100vw',
        position: 'relative'
      }}
    >
      <StyledLogoContainer>
        <LinearBLogoNew />
      </StyledLogoContainer>

      <StyledGridContainer
        container
        justifyContent='center'
        alignContent='center'
      >
        <Grid item lg={4} sm={8} xs={12}>
          <Card sx={{ margin: 3 }}>
            <LoginForm
              redirectUrl={redirectTo}
              authFlow={authFlow}
              invitationExpired={invitationExpired}
              invitationId={invitationId}
              locationState={location?.state?.error || null}
              toggleModal={toggleModal}
            />
          </Card>
        </Grid>
      </StyledGridContainer>
    </Background>
  );
};

export default Login;
